import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import router from './router'
import Data from './Store'
import BootstrapVue from 'bootstrap-vue'
import API from './API'
import Methods from './methods'
import VueMeta from 'vue-meta'
import VueTypedJs from 'vue-typed-js'
import Tawk from 'vue-tawk'

Vue.config.productionTip = false

Vue.use(VueTypedJs)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(API)
Vue.use(Methods)

Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/5d7b76519f6b7a4457e18142/1e8mrbt59'
})

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('awesome-icon', FontAwesomeIcon);

library.add(fas);
library.add(far);
library.add(fab);

Vue.use(VueMeta, { refreshOnceOnNavigation: true })

Vue.config.productionTip = false

require('./style.scss')

new Vue({
  data:Data,
  router,
  created() {
    window.addEventListener("resize", this.checkSize);
    this.checkSize();
    this.loadLanguage();
  },
  methods: {
    checkSize() {
      this.$root.$data.state.isMobile = window.matchMedia("only screen and (max-width: 1025px)").matches;
    }
  },
  render: h => h(App),
}).$mount('#app')
